import React from 'react'
import { cn } from '@/lib/utils'

/**
 * Placeholder block. The shimmer lives in `.lc-skeleton` (globals.css) and animates a
 * pseudo-element transform, so hundreds of these stay on the compositor.
 */
const Skeleton = ({ className, style }: { className?: string; style?: React.CSSProperties }) => (
  <div aria-hidden className={cn('lc-skeleton', className)} style={style} />
)

export default Skeleton
